
import { Component, Vue, Prop, Watch } from "vue-property-decorator";

import CSubscriptionUnitTestQuestion from "./test/Question.vue";
import CSubscriptionUnitTestResult from "./test/Result.vue";

import units_routes from "@/api/routes/units";

import SubscriptionUnit from "@/models/subscriptions/unit";
import TestQuestionVersion from "@/models/unit/unitable/test/question_version";
import TestVersion from "@/models/unit/unitable/test/version";

@Component({
  name: "CSubscriptionUnitTest",
  components: {
    CSubscriptionUnitTestQuestion,
    CSubscriptionUnitTestResult
  }
})
export default class CSubscriptionUnitTest extends Vue {
  @Prop({ required: true }) protected subscription_unit!: SubscriptionUnit;
  @Prop({ required: true }) private is_current_user_subscription!: boolean;

  public show_results: boolean = false;

  public current_question: TestQuestionVersion | null = null;
  public current_question_idx: number | null = null;
  public questions_count: number = 0;

  protected created() {
    this.loadTest();
  }

  @Watch("subscription_unit")
  private loadTest() {
    if (this.subscription_unit.isDone) {
      this.show_results = true;

      return;
    }

    const test_version = this.subscription_unit.unit_version
      .unitable as TestVersion;

    const first_not_answered_question_idx = test_version.question_versions.findIndex(
      qv => !qv.is_answered
    );

    this.questions_count = test_version.question_versions.length;

    if (first_not_answered_question_idx !== -1) {
      this.current_question_idx = first_not_answered_question_idx;
      this.current_question =
        test_version.question_versions[first_not_answered_question_idx];
    } else {
      this.show_results = true;
    }
  }

  public async nextQuestion(current_question_answered_ids: string[]) {
    if (this.current_question) {
      const corrects: boolean[] = [];
      const answered_ids: string[] = [];

      this.current_question.answer_versions.forEach(av => {
        const is_selected = current_question_answered_ids.includes(av.id);

        if (is_selected) {
          answered_ids.push(av.answer.id);
        }

        av.is_selected = is_selected;

        if (av.answer.is_correct && is_selected) {
          corrects.push(true);
        } else if (av.answer.is_correct && !is_selected) {
          corrects.push(false);
        } else if (!av.answer.is_correct && is_selected) {
          corrects.push(false);
        }
      });

      if (!answered_ids.length) {
        this.$notify({
          group: "notifications",
          type: "error",
          text: "Выберите вариант ответа",
          speed: 500
        });

        return;
      }

      return this.$api
        .post(units_routes.test_answer_results, {
          subscription_unit_id: this.subscription_unit.id,
          question_version_id: this.current_question.id,
          answer_ids: answered_ids
        })
        .then(() => {
          if (this.current_question && this.current_question_idx != null) {
            if (corrects.length && corrects.every(Boolean)) {
              this.current_question.is_correct = true;
            } else {
              this.current_question.is_correct = false;
            }

            if (this.current_question_idx < this.questions_count - 1) {
              this.current_question_idx++;

              this.current_question = (this.subscription_unit.unit_version
                .unitable as TestVersion).question_versions[
                this.current_question_idx
              ];
            } else {
              this.show_results = true;

              this.$emit("end", true);
            }
          }
        })
        .catch(({ response: res }) => {
          this.$notify({
            group: "notifications",
            type: "error",
            text: res.data.error,
            speed: 500
          });
        });
    }
  }
}
